import React from 'react'

export default function Facturacion() {
  return (
    <section>
        <div className='container'>
            <div>
                <h2>Solicitud de Factura</h2>
                <p>Dirígete a la recepción del barco y solicita el apoyo para realizar tu prefectura: </p>

                <label>La recepcionista te solicitará:</label>

                <ul>
                  <li>RFC</li>
                  <li>Razón Social</li>
                  <li>Dirección: (Colonia, calle, número, Municipio y CP)</li>
                  <li>Régimen Fiscal</li>
                  <li>Uso de la Factura</li>
                  <li>Correo</li>
                  <li>Teléfono</li>
                  <li>No. de Tickets a facturar	</li>

                </ul>

                <label>Se te entrega tu pre factura a bordo.</label>
                <p>Al 2do día hábil tras tu viaje se realizará el envío de tu factura por correo </p>


                <label>¿Necesitas facturar tu boleto de pasaje?</label>
                <p>Factúrala de manera fácil y rápida desde nuestra página web escaneando el código QR.</p>

                <label>Cualquier duda escribe a:</label>
                <p>facturas@bajaferries.com.mx</p>
               
            </div>

        </div>
    </section>
  )
}
